import { Questionnaire } from '@aspendental/needs-based-questions';
import { Box, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useQuery } from 'urql';

import { needsBasedQuestionsQuery } from './NeedsBasedQuestions.helpers';
import QuestionComponent from './QuestionComponent';
import ScriptingContainer from './ScriptingContainer';

export default function NeedsBasedQuestions({
	setNeedsBasedAnswers,
	needsBasedAnswers,
	hasError,
}: {
	setNeedsBasedAnswers: (answers: Record<string, string[]>) => void;
	needsBasedAnswers: Record<string, string[]> | undefined;
	hasError: boolean;
}) {
	const router = useRouter();
	const { locale } = router;

	const [{ data }] = useQuery({
		query: needsBasedQuestionsQuery,
		variables: {
			questionnaireId: 'nbq_public_website',
			language: locale?.toLocaleLowerCase() || 'en-us',
		},
	});

	const { t } = useTranslation('needsBasedQuestions');

	if (!data?.questionnaire?.questions?.length) return null;

	return (
		<Box mx={2} mt={4}>
			<Box mb={2}>
				<Typography data-test-id="nbq-get-to-know-you-text" variant="header3">
					{t('getToKnow')}
				</Typography>
			</Box>
			<Box mb={2}>
				<Typography variant="bodyMediumBold">{t('provideInfo')}</Typography>
			</Box>
			<Questionnaire
				questionnaireQuestions={data?.questionnaire?.questions as any}
				QuestionComponent={QuestionComponent}
				ScriptingContainer={ScriptingContainer}
				onAnswersUpdated={setNeedsBasedAnswers as any}
				answersInitialState={needsBasedAnswers}
				hasError={hasError}
			/>
		</Box>
	);
}
